import { IDEA_ROW } from '@/constants/idea'
import EventBus from '@/EventBus'
import isLocalId from '@/utils/initiative/isLocalId'
import * as R from 'ramda'
import { mapActions } from 'vuex'

/**
 * This mixins contains some of the methods to operate on ideas
 */

export default {
  computed: {
    openIdeas() {
      return this.ideas ? this.ideas.filter(R.propEq('isDone', false)) : []
    },
    completedIdeas() {
      return this.ideas ? this.ideas.filter(R.propEq('isDone', true)) : []
    },
    groupedIdeas() {
      return [...this.openIdeas, ...this.completedIdeas]
    }
  },
  methods: {
    ...mapActions('idea', ['getIdeas']),
    async fetchIdeas({ orgId, ideaListId }) {
      try {
        let ideas = await this.getIdeas({ orgId, ideaListId })
        if (this.ideas?.every(x => isLocalId(x.id))) {
          // if user is creating some ideas before the response, it should be appended
          ideas = [...ideas, ...this.ideas]
        }
        this.ideas = ideas
        this.ideasCopy = ideas
      } catch (e) {
        const status = R.path(['response', 'status'], e)
        if (status === 404) {
          EventBus.$emit('SHOW_404')
        }
      }
    },
    /**
     * This replaces *ideasToUpdate* with coresponding idea from *ideas*
     * If idea is marked done/undone, it refreshes the list
     * @param ideas
     * @param ideaToUpdate
     * @returns {f2|f1}
     */
    injectUpdatedIdea(ideas, ideaToUpdate) {
      const ideaId = ideaToUpdate.localId || ideaToUpdate.id
      const ideaIndex = this.ideas.findIndex(x => x.id === ideaId || x.localId === ideaId)
      if (this.ideas[ideaIndex]['isDone'] !== ideaToUpdate.isDone) {
        // status is changed, refresh the ideas
        this.fetchIdeas({
          ideaListId: ideaToUpdate.listId,
          orgId: ideaToUpdate.organizationId
        })
      } else {
        return R.update(ideaIndex, ideaToUpdate, this.ideas)
      }
    },
    async handleIdeaUpdate(idea) {
      let updatedIdeas = this.injectUpdatedIdea(this.ideas, idea)
      if (updatedIdeas) {
        this.ideas = updatedIdeas
      }
      updatedIdeas = this.injectUpdatedIdea(this.ideasCopy, idea)
      if (updatedIdeas) {
        this.ideasCopy = updatedIdeas
      }
    },
    deleteIdea(idea) {
      this.ideas = this.ideas.filter(x => x.id !== idea.id)
      this.ideasCopy = this.ideasCopy.filter(x => x.id !== idea.id)
    },
    // TODO: functions - getIdeaRowVue, cancelIdeaEditing focusTabPin, getSelectedIdeaVueComponent and moveIdea  are available in IdeasKeyboardNavMixins. Use same
    /**
     * This function accepts a DOM node inside idea row and it will return the reference of Vue component for the initiatidea   * @param node
     * @returns {null|*|null|*}
     */
    getIdeaRowVue(node) {
      if (!node) return null
      if (R.pathEq(['__vue__', '$options', 'name'], IDEA_ROW, node)) {
        return node.__vue__
      } else return this.getIdeaRowVue(node.parentElement)
    },
    /**
     * This can be used to take user out of edit mode of idea
     */
    cancelIdeaEditing() {
      const active = document.activeElement
      if (active) {
        const ideaVue = this.getIdeaRowVue(active)
        ideaVue && ideaVue.cancelIdeaEdit()
      }
    },
    /**
     * This focuses the tab-pin of selected row, so that tab-key can take focus to next status checkbox
     * @returns {Vue}
     * @type {Element}
     */
    focusTabPin() {
      const selected = this.$el.querySelector('.idea-row.selected')
      if (selected) {
        const tabPin = selected.querySelector('.tab-pin')
        tabPin &&
          tabPin.focus({
            preventScroll: true
          })
      }
    },
    /**
     * This function can be used to create random id
     * @returns {string}
     */
    createIdeaId() {
      return (
        'local-' +
        Math.random()
          .toString()
          .split('.')[1]
      )
    },
    getSelectedIdeaVueComponent() {
      let selectedItem = this.$el.querySelector('.selected')
      if (selectedItem) {
        return selectedItem.__vue__
      }
    },
    moveIdea() {
      let idea = this.getSelectedIdeaVueComponent()
      if (idea) {
        idea.showMoveIdea = true
      }
    },
    onIdeaMoved({ idea }) {
      this.fetchIdeas({ orgId: idea.organizationId, krId: idea.listId })
    },
    focusAddCommentEditor() {
      const commentField = this.$el.querySelector('#addComment')
      commentField && commentField.click()
    }
  }
}
